export var amountAndPercentageFinder = function amountAndPercentageFinder(_ref) {
  var showPromoBoost = _ref.showPromoBoost,
    item = _ref.item;
  var percent = showPromoBoost ? item.PROMO_BOOST_PERCENTAGE : parseInt(item.PERCENT_BOOST, 10);
  var hasGenericSale = item.HAS_GENERIC_SALE && item.GENERIC_SALE_PERCENTAGE > 0;
  var genericSalePercentage = item.GENERIC_SALE_PERCENTAGE;
  var hasExclusiveSale = !hasGenericSale && item.IS_SALE && item.EXCLUSIVE_SALE_PERCENTAGE > 0;
  var exclusiveSalePercentage = item.EXCLUSIVE_SALE_PERCENTAGE;
  var itemOnSale = hasExclusiveSale || hasGenericSale;
  var coinAmount = item.AMOUNT;
  if (showPromoBoost && !itemOnSale) {
    coinAmount = item.PROMO_BOOSTED_VALUE;
  } else if (showPromoBoost && itemOnSale) {
    coinAmount = item.AMOUNT_INCLUDING_SALE_AND_PROMO;
  }
  return {
    coinAmount: coinAmount,
    percent: percent,
    hasExclusiveSale: hasExclusiveSale,
    exclusiveSalePercentage: exclusiveSalePercentage,
    hasGenericSale: hasGenericSale,
    genericSalePercentage: genericSalePercentage,
    itemOnSale: itemOnSale
  };
};